import { setFamilyEngagementCategory } from '@/buddy/facilities/bundles-new/familyEngagementCore/FamilyEngagementCoreService';
import { setConciergeCategory, setLifestyleCategory } from '@/buddy/facilities/bundles-new/familyEngagementPlus/FamilyEngagementPlusService';
import { setMaintenanceCategory } from '@/buddy/facilities/bundles-new/maintenance/MaintenanceService';
import { setDigitalSignageCategory } from '@/buddy/facilities/bundles/digitalSignage/DigitalSignageBundleService';
import { FeatureBundles } from '@/enums/FeatureBundles';

export const setFacilityFeatureBundles = (facility: any, featureBundlesNames: string[], value: boolean) => {

  featureBundlesNames.forEach((bundleName: string) => {

    facility.modules = facility.modules || {}

    if (bundleName === FeatureBundles.FamilyEngagementCore) {
      facility.modules.familyEngagementCore = facility.modules.familyEngagementCore || {}
      facility.modules.familyEngagementCore.isEnabled = value
      facility.featureFamilyEngagement = value
      setFamilyEngagementCategory(facility, value)
    }

    if (bundleName === FeatureBundles.LifestyleAndConcierge) {
      facility.modules.familyEngagementPlus = facility.modules.familyEngagementPlus || {}
      facility.modules.familyEngagementPlus.isEnabled = value
      facility.featureLifestyle = value
      facility.featureConcierge = value
      setLifestyleCategory(facility, value)
      setConciergeCategory(facility, value)
    }

    if (bundleName === FeatureBundles.Maintenance) {
      facility.modules.maintenance = facility.modules.maintenance || {}
      facility.modules.maintenance.isEnabled = value
      facility.featureMaintenance = value;
      setMaintenanceCategory(facility, value)
    }

    if (bundleName === FeatureBundles.DigitalSignage) {
      facility.modules.digitalSignage = facility.modules.digitalSignage || {}
      facility.modules.digitalSignage.isEnabled = value
      facility.featureDigitalSignage = value;
      setDigitalSignageCategory(facility, value)
    }
  });

  return facility;
};
